import classNames from "classnames/bind";
import styles from "./Kicker.module.css";

const cx = classNames.bind(styles);

export function Kicker({ text }: { text: string }) {
  return <p className={cx("kicker")}>{text}</p>;
}
